// extracted by mini-css-extract-plugin
module.exports = {"titleIcon":"ViewChargeAffirm_titleIcon__esxDK","inputPhoneContainer":"ViewChargeAffirm_inputPhoneContainer__1UVH7"};